import { clsx, type ClassValue } from 'clsx';

/** Join class names, dropping falsy ones. */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
